export default "__VITE_ASSET__FZho7Dca__"